export default ['$scope', '$uibModalInstance', 'popupService', '$rootScope', 'options',
  function ($scope, $uibModalInstance, popupService, $rootScope, options) {

    $scope.finish = () => {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.$on('modal.closing', (_, type) => {
      options.onFinish && options.onFinish();
    });
  }
];
